<app-popin [popinTitle]="folderTitle$ | async"
           [subtitle]="folderName$ | async"
           subtitleIcon="folder">
  <div content>
    <app-input appearance="outline"
               [label]="'folders.folder_name' | translate"
               [hint]="'folders.enter_folder_name' | translate"
               controlName="name"
               [form]="form"
               [errors]="{ required: 'errors.required' }"></app-input>
    <app-folder-selector [form]="form"
                         [folderIdToMove]="folderIdToMove$ | async"
                         controlName="parent_folder_id"></app-folder-selector>
  </div>
  <div actions>
    <app-button type="reset"
                buttonType="mat-button"
                [disabled]="loading$ | async"
                (onClick)="dialogRef.close()">{{ 'button.cancel' | translate }}</app-button>
    <app-button type="submit"
                buttonType="mat-raised-button"
                [disabled]="!form.valid || (loading$ | async)"
                [loader]="loading$ | async"
                icon="done"
                (onClick)="onCreate()">{{ submitButtonText$ | async | translate }}</app-button>
  </div>
</app-popin>
